export default __webpack_public_path__ + "static/media/news.8d63f484.svg";